// Single source of truth for the customer-facing contact address.
export const CONTACT_EMAIL = "hello@harukihealth.com";
